import { AST } from '@handlebars/parser';
import {
  createBlockStatement,
  createContentStatement,
} from 'modules/handlebars/domain/statement/utils';
import { isDefined } from 'utils/tsHelpers';
import { createProgram } from 'modules/handlebars/domain/program';
import type { ConditionalContent } from '../../domain';
import { createBlockStatementConfigFromConditionalContent } from './createBlockStatementConfigFromConditionalContent';

export const createInverseFromConditionalContent = (
  conditionalContent: ConditionalContent,
): AST.Program => {
  const { elseIfClauses, defaultContent } = conditionalContent;
  /** recurses to create inverse */
  if (elseIfClauses.length > 0) {
    const [ifClause, ...subsequentElseIfClauses] = elseIfClauses;
    const newDynamicContent: ConditionalContent = {
      ifClause,
      elseIfClauses: subsequentElseIfClauses,
      defaultContent,
    };

    const config = createBlockStatementConfigFromConditionalContent(newDynamicContent);
    const inverse = createInverseFromConditionalContent(newDynamicContent);
    const blockStatement = [createBlockStatement({ ...config, inverse })];
    return createProgram({ body: blockStatement });
  } else if (isDefined(defaultContent) && defaultContent.length > 0) {
    /** creates inverse default */
    const contentStatement = [createContentStatement(defaultContent)];
    return createProgram({ body: contentStatement });
  } else {
    return createProgram({ body: [] });
  }
};
